import React, { useRef } from 'react'
import { useMemo } from 'react';
import { useAccount } from 'wagmi'
import { useEffect } from 'react';
import { whiteList } from '@/utils/index'


function debounce(func, wait) {
  let timeout
  return function(...args) {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => func.apply(context, args), wait)
  }
}


export const useInterval = (callback, delay) => {
  const savedCallback = React.useRef();

  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  React.useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    let id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, []);
};


// Hook
export const useDebounce = (callback) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = callback;
  }, [callback]);

  const debouncedCallback = useMemo(() => {
    const func = () => {
      ref.current?.();
    };

    return debounce(func, 1000);
  }, []);

  return debouncedCallback;
};

// Hook
export const useWhiteList = () => {
  const { address } = useAccount();
  const isInWhiteList = whiteList.map(i => i.toLowerCase()).indexOf(address?.toLowerCase() || '') !== -1  
  return isInWhiteList;
};

